import React, { useState, useEffect, useContext } from 'react'
import { WdContext } from "../../context/WdProvider";
import WplTable from "../wpl-table/WplTable";
import WplTabs from "../wpl-tabs/WplTabs";
import Card from "../card/Card";
import './blade-defect-table.css'

export default function BladeDefectTable({ defects }) {
    const { selectedDefect, setSelectedDefect } = useContext(WdContext);
    const [selectedBlade, setSelectedBlade] = useState('')
    const [blades, setBlades] = useState([]);

    useEffect(() => {
        if (!defects || defects.length === 0) return;

        let uniqueBlades = defects
            .map(d => d.blade)
            .filter(b => b != null)
            .filter((b, idx, arr) => arr.indexOf(b) === idx)
            .sort((a, b) => a.localeCompare(b));

        setBlades(uniqueBlades);
        setSelectedBlade(prev => prev || uniqueBlades[0]);
    }, [defects, setSelectedBlade]);

    if (defects.length === 0) return null;

    return (<Card className='blade-defect-table'>
        <h1>Grouped by blade</h1>
        <WplTabs tabTitles={blades} selected={selectedBlade} setSelected={setSelectedBlade} />
        <WplTable className='blade-table'
            defects={defects.filter(d => d.blade === selectedBlade)}
            setSelectedDefect={setSelectedDefect}
            selectedDefect={selectedDefect}
            inlineSelectable={true}
        />
    </Card>)
}
